<template>
  <div>
    <filter-sidebar
      v-model="formattedFilters"
      :isSidebarActive="showSidebar"
      @submit="applyFilters"
      @closeSidebar="toggleSidebar"
    />
    <vs-card v-if="!displayForm" class="cardx">
      <div slot="header" style="padding: 10px">
        <h3>
          Trips ({{ trips.pagination.total }} items)

          <div style="float: right"></div>
        </h3>
      </div>

      <div>
        <vs-table search :sst="true" @search="handleSearch" :data="trips.trips">
          <template slot="header">
            <vs-row>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="12" style="display: table">
                <div style="float: left; margin-bottom: 10px">
                  <vs-button
                    :disabled="selected.length === 0"
                    @click="bulkDelete"
                    class="mr-3 small"
                    color="danger"
                    type="filled"
                  >
                    <trash2-icon size="12" class="mr-2" />
                    Delete
                  </vs-button>

                  <vs-dropdown
                    class="vs-component vs-button vs-button-primary vs-button-filled small"
                  >
                    <div style="color: white">Copy trips</div>
                    <vs-dropdown-menu style="width: 200px">
                      <vs-dropdown-item
                        class="pt-1 pb-1"
                        @click="cloneDialog('ZONE')"
                      >
                        By zone
                      </vs-dropdown-item>
                      <vs-dropdown-item
                        class="pt-1 pb-1"
                        @click="cloneDialog('ROUTE')"
                      >
                        By route
                      </vs-dropdown-item>
                      <vs-dropdown-item
                        class="pt-1 pb-1"
                        @click="cloneDialog('VEHICLE')"
                      >
                        By vehicle
                      </vs-dropdown-item>
                      <vs-dropdown-item
                        class="pt-1 pb-1"
                        @click="cloneDialog('DRIVER')"
                      >
                        By driver
                      </vs-dropdown-item>
                      <vs-dropdown-item
                        :disabled="selected.length === 0"
                        class="pt-1 pb-1"
                        @click="cloneDialog('TRIP')"
                      >
                        Selected trips
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
                <vs-row style="margin-top: 10px; margin-bottom: 10px">
                  <div
                    style="margin-bottom: 5px; margin-left: 0px; float: left"
                  >
                    <vs-button
                      @click="MassLoad"
                      color="primary"
                      type="filled"
                      icon="arrow_downward"
                      size="small"
                      >Import</vs-button
                    >
                  </div>
                  <div
                    style="margin-bottom: 5px; margin-left: 15px; float: left"
                  >
                    <vs-button
                      @click="Exportxls"
                      color="primary"
                      type="filled"
                      icon="arrow_upward"
                      size="small"
                      >Export</vs-button
                    >
                  </div>
                  <div
                    style="margin-bottom: 5px; margin-left: 15px; float: left"
                  >
                    <a href="/admin/trips/add" target="_self">
                      <vs-button
                        color="primary"
                        type="filled"
                        icon="add"
                        size="small"
                        >New</vs-button
                      >
                    </a>
                  </div>
                </vs-row>
              </vs-col>

              <vs-col vs-lg="4" vs-sm="4" vs-xs="12" style="display: table">
                <vs-chip
                  transparent
                  @click="toggleSidebar(true)"
                  closable
                  close-icon="add"
                >
                  Add Filter
                </vs-chip>

                <vs-row>
                  <vs-dropdown
                    class="mr-2"
                    vs-custom-content
                    vs-trigger-click
                    vs-drop-right
                    :vs-dropdown-visible="true"
                  >
                    <vs-chip
                      transparent
                      color="primary"
                      style="min-width: 200px; margin: 0; padding: 0"
                    >
                      <calendar-icon size="12" class="mr-2" />
                      {{ fromDateFormat }} - {{ toDateFormat }}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker
                        :highlighted="highlighted"
                        calendar-class="border-none"
                        :inline="true"
                        v-model="dateModel"
                        format="yyyy-MM-dd"
                      ></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </vs-row>

                <vs-chip
                  v-if="
                    [
                      'zone_id',
                      'partner_id',
                      'status',
                      'route_id',
                      'driver_id',
                      'vehicle_id',
                    ].indexOf(key) > -1
                  "
                  transparent
                  color="primary"
                  :key="'el-' + key"
                  v-for="(filter, key) of formattedFilters"
                  @click="removeFilter(key)"
                  closable
                >
                  <FlagIcon v-if="key === 'zone_id'" size="12" class="mr-2" />
                  <GitBranchIcon
                    v-if="key === 'route_id'"
                    size="12"
                    class="mr-2"
                  />
                  <TruckIcon
                    v-if="key === 'vehicle_id'"
                    size="12"
                    class="mr-2"
                  />
                  <UserIcon v-if="key === 'driver_id'" size="12" class="mr-2" />
                  <BriefcaseIcon
                    v-if="key === 'partner_id'"
                    size="12"
                    class="mr-2"
                  />
                  <b>{{ filter.field }}</b
                  >: {{ filter.text }}
                </vs-chip>
              </vs-col>
            </vs-row>
          </template>
          <template slot="thead">
            <vs-th>
              <vs-checkbox size="small" v-model="selectAll"></vs-checkbox>
            </vs-th>
            <vs-th sort-key="date" style="min-width: 120px"> Date </vs-th>
            <vs-th sort-key="Time"> Time </vs-th>
            <vs-th sort-key="Route" style="min-width: 350px"> Route </vs-th>
            <vs-th> Zone </vs-th>
            <vs-th sort-key="status"> Status </vs-th>
            <vs-th sort-key="Eco"> Eco </vs-th>
            <vs-th sort-key="external-id"> ID </vs-th>
            <vs-th sort-key="Driver_name"> Driver </vs-th>
            <vs-th> Seats </vs-th>
            <vs-th> Bookings </vs-th>
            <vs-th style="min-width: 150px"> Action </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              :state="getRowState(trip)"
              :key="trip.id"
              v-for="trip in data"
            >
              <vs-td>
                <vs-checkbox
                  size="small"
                  v-model="selected"
                  :vs-value="trip.id"
                ></vs-checkbox>
              </vs-td>
              <vs-td>
                {{ trip.date }}
              </vs-td>
              <vs-td>
                {{ trip.hour_start }}<br />
                {{ trip.hour_end }}
              </vs-td>

              <vs-td>
                <router-link :to="showTrip(trip.id)">{{
                  trip.route.name
                }}</router-link>
                <div>
                  <vs-chip
                    class="station-chip"
                    :key="index + '-' + trip.id"
                    v-for="(st, index) in trip.stations"
                    transparent
                    :color="getChipStationColor(trip.status, st.status)"
                  >
                    {{ timeFormat(st.departure) }}
                  </vs-chip>
                </div>
              </vs-td>
              <vs-td>
                {{ trip.route.zone.name }}
              </vs-td>
              <vs-td>
                <vs-chip transparent :color="getChipColor(trip.status)">
                  {{ trip.status }}
                </vs-chip>
              </vs-td>
              <vs-td>
                {{ trip.vehicle.eco_number }}
              </vs-td>
              <vs-td>
                {{ trip.vehicle.external_id }}
              </vs-td>
              <vs-td>
                {{ trip.driver.firstname }} {{ trip.driver.lastname }}
              </vs-td>
              <vs-td style="text-align: center">
                {{ trip.seats }}
              </vs-td>
              <vs-td style="text-align: center">
                {{ trip.bookings }}
              </vs-td>
              <vs-td>
                <router-link :to="copy(trip.id)">
                  <feather-icon
                    icon="CopyIcon"
                    class="cursor-pointer navbar-fuzzy-search mr-4"
                  />
                </router-link>
                <router-link :to="edit(trip.id)">
                  <feather-icon
                    icon="EyeIcon"
                    class="cursor-pointer navbar-fuzzy-search mr-4"
                  />
                </router-link>

                <feather-icon
                  icon="Trash2Icon"
                  @click="openConfirm(trip.id)"
                  class="cursor-pointer navbar-fuzzy-search mr-4 text-danger"
                />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="mt-3 mb-3">
          <span style="float: left">
            <vs-select
              @input="page = 1"
              class=""
              label=""
              v-model="limit"
              width="100px"
              size="small"
            >
              <vs-select-item
                :key="'lim-' + index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in limitOptions"
              />
            </vs-select>
          </span>
          <pagination :last-page="trips.pagination.pages" v-model="page" />
        </div>
      </div>
    </vs-card>

    <vs-card
      v-if="displayForm"
      class="cardx card-100-h"
      v-bind:style="{ height: windowHeight - 155 + 'px' }"
    >
      <div>
        <vs-row>
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding: 10px">
            <div>
              <h3 style="margin-bottom: 10px">{{ formTitle }}</h3>

              <div>
                <vs-row>
                  <vs-col
                    vs-lg="12"
                    vs-sm="12"
                    vs-xs="12"
                    style="padding: 10px"
                  >
                    <label class="vs-input--label">Partner</label>
                    <v-select
                      v-model="partner_id"
                      name="partner"
                      :options="partners"
                      :reduce="(el) => el.id"
                      label="name"
                    />
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding: 10px">
                    <input
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv"
                      ref="file"
                      type="file"
                      @click="uploadFile"
                    />
                  </vs-col>
                </vs-row>
              </div>
              <div class="mb-4">
                <vs-button
                  class="mr-3"
                  @click="Masssave"
                  color="danger"
                  type="filled"
                  :disabled="showError"
                  >Guardar</vs-button
                >
                <vs-button @click="cancel" color="primary" type="filled"
                  >Cancelar</vs-button
                >
              </div>
            </div>
          </vs-col>
        </vs-row>

        <vs-row v-if="showError">
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
            <h3>Import error</h3>
          </vs-col>
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
            <vs-table stripe :data="errors_array">
              <template slot="thead">
                <vs-th> Line </vs-th>
                <vs-th> Trip id </vs-th>
                <vs-th> Route id </vs-th>
                <vs-th> Driver id </vs-th>
                <vs-th> Vehicle id </vs-th>
                <vs-th> Partner id </vs-th>
                <vs-th> Station id </vs-th>
                <vs-th> Date </vs-th>
                <vs-th> Seats </vs-th>
                <vs-th> Price </vs-th>
                <vs-th> Order </vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="indextr">
                    {{ parseInt(Object.keys(data[indextr])) }}
                  </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))].id
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))].id[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .route_id
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .route_id[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .driver_id
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .driver_id[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .vehicle_id
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .vehicle_id[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .partner_id
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .partner_id[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .station_id
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .station_id[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))].date
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .date[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))].seats
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .seats[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))].price
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .price[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                  <vs-td
                    v-if="
                      data[indextr][parseInt(Object.keys(data[indextr]))].order
                    "
                  >
                    {{
                      data[indextr][parseInt(Object.keys(data[indextr]))]
                        .order[0]
                    }}
                  </vs-td>
                  <vs-td v-else> </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-row>
              <vs-col style="margintop: 10px">
                <vs-button
                  @click="showError = false"
                  color="primary"
                  type="filled"
                  size="small"
                  >Ok</vs-button
                >
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>

    <vs-popup :title="cloneTitle" :active.sync="showCloneForm">
      <div v-if="cloneForm.source.ids.length === 0">
        <zones v-if="cloneForm.source.type === 'ZONE'" v-model="selected" />
        <routes v-if="cloneForm.source.type === 'ROUTE'" v-model="selected" />
        <vehicles
          v-if="cloneForm.source.type === 'VEHICLE'"
          v-model="selected"
        />
        <drivers v-if="cloneForm.source.type === 'DRIVER'" v-model="selected" />
        <vs-row style="float: bottom">
          <vs-col>
            <vs-button
              class="mr-3"
              @click="cancelCloneDialog"
              color="primary"
              type="filled"
              >Cancel</vs-button
            >
            <vs-button
              color="danger"
              :disabled="selected.length === 0"
              @click="selectDates"
              type="filled"
              style="float: right"
              >Continue</vs-button
            >
          </vs-col>
        </vs-row>
      </div>
      <div v-if="cloneForm.source.ids.length > 0 && !taskId">
        <p>Schedule dates:</p>
        <vs-row style="margin-bottom: 20px">
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
            <div style="margin-right: 20px">
              <flat-pickr
                v-model="cloneForm.schedule.start_date"
                v-validate="`required`"
                name="start_date"
                data-vv-as="start date"
                :class="
                  errors.has('start_date')
                    ? 'flatpickr-input border-danger w-full'
                    : 'flatpickr-input  w-full'
                "
                placeholder="From date"
                style="width: 100%"
              ></flat-pickr>
              <span>
                <div
                  class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
                  style=""
                >
                  <span class="span-text-validation">{{
                    errors.first("start_date")
                  }}</span>
                </div>
              </span>
            </div>
          </vs-col>
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
            <div style="">
              <flat-pickr
                v-model="cloneForm.schedule.end_date"
                v-validate="
                  `required|date_gte:${cloneForm.schedule.start_date}`
                "
                name="end_date"
                data-vv-as="end date"
                :class="
                  errors.has('end_date')
                    ? 'flatpickr-input border-danger w-full'
                    : 'flatpickr-input  w-full'
                "
                placeholder="To date"
                style="width: 100%"
              ></flat-pickr>
              <span>
                <div
                  class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
                  style=""
                >
                  <span class="span-text-validation">{{
                    errors.first("end_date")
                  }}</span>
                </div>
              </span>
            </div>
          </vs-col>
        </vs-row>
        <vs-row style="margin-bottom: 20px">
          <vs-col
            v-if="cloneForm.source.type !== 'TRIP'"
            vs-lg="6"
            vs-sm="6"
            vs-xs="12"
          >
            <p>Base date:</p>
            <div style="margin-right: 20px">
              <flat-pickr
                v-model="cloneForm.source.date"
                v-validate="'required'"
                name="date"
                data-vv-as="base date"
                :class="
                  errors.has('date')
                    ? 'flatpickr-input border-danger w-full'
                    : 'flatpickr-input  w-full'
                "
                placeholder="Date"
                style="width: 100%"
              ></flat-pickr>
              <span>
                <div
                  class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
                  style=""
                >
                  <span class="span-text-validation">{{
                    errors.first("date")
                  }}</span>
                </div>
              </span>
            </div>
          </vs-col>
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
            <p>Exclude:</p>
            <vs-select
              class=""
              style="width: 100%"
              label=""
              v-model="cloneForm.schedule.exclude"
              multiple
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in excludeOptions"
              />
            </vs-select>
          </vs-col>
        </vs-row>
        <vs-row class="mt-2" style="float: bottom">
          <vs-col>
            <vs-button
              class="mr-3"
              :disabled="submitClone"
              @click="cancelCloneDialog"
              color="primary"
              type="filled"
              >Cancel</vs-button
            >
            <vs-button
              color="danger"
              :disabled="submitClone"
              @click="cloneTrips"
              type="filled"
              style="float: right"
              >Submit</vs-button
            >
          </vs-col>
        </vs-row>
      </div>
      <div v-if="taskId">
        <vs-row style="margin-bottom: 20px">
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-slider disabled="true" v-model="progress" :min="0" :max="100" />
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>

    <vs-popup
      @close="showProgress = false"
      button-close-hidden
      class="crop-modal"
      title="Import Progress"
      :active.sync="showProgress"
    >
      <vs-row>
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
          Progress of import:
        </vs-col>
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
          <div
            :style="{
              background: 'red',
              height: '15px',
              width: progress + '%',
            }"
          ></div>
          <div
            style="
              fontsize: 1rem;
              fontweight: bold;
              color: red;
              textalign: center;
            "
          >
            {{ progress }}%
          </div>
        </vs-col>
        <vs-col
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
          style="padding: 10px; textalign: center"
          v-if="progress === 100"
        >
          <vs-button
            @click="showProgress = false"
            color="primary"
            type="filled"
            size="small"
            >Ok</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<style>
.filter-icon {
  font-size: 12px;
}

.border-none {
  border: none !important;
}

.station-chip > span {
  font-size: 8px;
  margin-left: 5px;
  min-height: 20px;
}

.station-chip {
  padding-right: 5px;
}

.limit-select {
  margin-right: 5px;
}

.limit-select > div > input {
  height: 26px !important;
  border-radius: 23px;
}
.vs-notifications {
  z-index: 999999 !important;
}
</style>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import {
  CalendarIcon,
  FlagIcon,
  BriefcaseIcon,
  GitBranchIcon,
  TruckIcon,
  UserIcon,
  XIcon,
  PlusIcon,
  FilterIcon,
  Trash2Icon,
} from "vue-feather-icons";
import FilterSidebar from "./FilterSidebar";
import { isEqual } from "lodash";
import zones from "../../components/tables/zones";
import routes from "../../components/tables/routes";
import vehicles from "../../components/tables/vehicles";
import drivers from "../../components/tables/drivers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import limit from "../../constants/limit";

const FileDownload = require("js-file-download");

export default {
  name: "Trips",
  components: {
    Datepicker,
    CalendarIcon,
    FlagIcon,
    BriefcaseIcon,
    GitBranchIcon,
    TruckIcon,
    UserIcon,
    XIcon,
    PlusIcon,
    FilterIcon,
    Trash2Icon,
    FilterSidebar,
    zones,
    routes,
    vehicles,
    drivers,
    flatPickr,
  },
  data() {
    return {
      page: 0,
      limit: 50,
      search: null,
      dateModel: null,
      newDate: new Date(),
      fromDate: new Date(),
      toDate: moment().toDate(),
      query: {},
      showSidebar: false,
      formattedFilters: {},
      selected: [],
      windowHeight: 0,
      displayForm: false,
      cloneForm: { source: { ids: [] }, schedule: {} },
      showCloneForm: false,
      submitClone: false,
      taskId: null,
      progress: 0,
      showProgress: false,
      showError: false,
      lastDate: "from",
      excludeOptions: [
        { text: "Monday", value: "MONDAY" },
        { text: "Tuesday", value: "TUESDAY" },
        { text: "Wednesday", value: "WEDNESDAY" },
        { text: "Thursday", value: "THURSDAY" },
        { text: "Friday", value: "FRIDAY" },
        { text: "Saturday", value: "SATURDAY" },
        { text: "Sunday", value: "SUNDAY" },
      ],
      limitOptions: limit,
    };
  },
  computed: {
    ...mapState(["partner_namespace"]),
    ...mapGetters("users", ["userCan"]),
    ...mapState("trips", ["trips", "currentPage", "filters"]),
    date() {
      return moment(this.newDate).format("YYYY-MM-DD");
    },
    fromDateFormat() {
      return moment(this.fromDate).format("YYYY-MM-DD");
    },
    toDateFormat() {
      return moment(this.toDate).format("YYYY-MM-DD");
    },
    highlighted() {
      return {
        to: this.toDate,
        from: this.fromDate,
      };
    },
    cloneTitle() {
      if (this.cloneForm.source.ids.length === 0) {
        return `Select ${this.cloneForm.source.type}S`;
      }
      if (this.cloneForm.source.ids.length > 0) {
        return "Schedule";
      }
    },
    selectAll: {
      get() {
        let ids = this.trips.trips.map((item) => item.id);
        let inter = _.intersection(this.selected, ids);
        return inter.length === this.trips.trips.length;
      },
      set(value) {
        let selected = _.cloneDeep(this.selected);
        let ids = this.trips.trips.map((item) => item.id);
        if (value) {
          selected = _.union(selected, ids);
        } else {
          selected = _.pullAll(selected, ids);
        }
        this.selected = selected;
      },
    },
  },
  created() {
    this.query = { ...this.$route.query };
    if (this.partner_namespace) {
      this.query.partner_id = this.partner_namespace;
    }
    let page = this.$route.query.page ? Number(this.$route.query.page) : 1;
    if (page === 0) {
      page = 1;
    }
    if (page === "0") {
      page = 1;
    }
    this.page = page;
    this.limit = this.$route.query.limit ? Number(this.$route.query.limit) : 10;
    this.fromDate = this.$route.query.from_date
      ? moment(this.$route.query.from_date, "YYYY-MM-DD").toDate()
      : new Date();
    this.toDate = this.$route.query.to_date
      ? moment(this.$route.query.to_date, "YYYY-MM-DD").toDate()
      : moment().toDate();
    this.dateModel = moment(this.fromDate).toDate();
    this.doSearch = _.debounce(this.getItems, 300);
  },
  mounted() {
    this.initialData();
  },
  watch: {
    page(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getItems(this.search);
      }
    },
    limit(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getItems(this.search);
      }
    },
    filters(newValue) {
      let query = {};
      for (let key in newValue) {
        query[key] = newValue[key].value;
      }
      this.query = query;
      if (this.page === 1 || this.page === "1") {
        this.getItems();
      } else {
        this.page = 1;
      }
    },
    dateModel(newValue, oldValue) {
      console.log("date", newValue);
      console.log("date", oldValue);

      let fromDate = moment(this.fromDate);
      let toDate = moment(this.toDate);
      let date = moment(newValue);
      if (date.isSame(toDate) && oldValue) {
        this.fromDate = date.toDate();
        this.lastDate = "to";
        this.page = 1;
        console.log("toDate", this.fromDate);
        this.getItems(null);
        return;
      }
      if (date.isSame(fromDate) && oldValue) {
        this.toDate = date.toDate();
        this.lastDate = "from";
        this.page = 1;
        console.log("fromDate", this.toDate);
        this.getItems(null);
        return;
      }
      if (date.isBefore(fromDate)) {
        this.fromDate = date.toDate();
        console.log("isBefore-fromDate", date.toDate());
        this.toDate = fromDate.toDate();
        this.lastDate = "from";
        this.page = 1;
        console.log("isBefore-fromDate", this.fromDate);
        this.getItems(null);
        return;
      }
      if (date.isBefore(toDate)) {
        if (this.lastDate === "from" && oldValue) {
          this.toDate = date.toDate();
          this.lastDate = "to";
        } else {
          this.fromDate = date.toDate();
          this.lastDate = "from";
        }
        this.page = 1;
        this.getItems(null);
        return;
      }
      if (date.isAfter(fromDate)) {
        this.toDate = date.toDate();
        this.lastDate = "to";
        this.page = 1;
        console.log("isAfter", this.toDate);
        this.getItems(null);
        return;
      }
    },
  },
  methods: {
    ...mapActions("trips", [
      "fetchTrips",
      "deleteTrip",
      "bulkDeleteTrips",
      "storeBulkTrips",
      "getTaskProgress",
      "fetchTripsReport",
      "CheckTripsProgress",
      "MassLoadTrips",
    ]),
    ...mapActions("partners", ["fetchPartners"]),
    ...mapMutations("trips", ["SET_FILTERS"]),
    customFormatter(date) {
      return moment(date).format("yyyy-MM-dd");
    },
    initialData() {
      this.fetchPartners({ limit: 500 }).then((data) => {
        if (this.partner_namespace) {
          data.data.partners.map((item) => {
            if (this.partner_namespace === item.id) {
              let temparray = [];
              temparray.push(item);
              this.partners = _.cloneDeep(temparray);
            }
          });
        } else {
          this.partners = _.cloneDeep(data.data.partners);
        }
      });
      /*
      this.fetchRoutes({limit: 500});
      this.fetchDrivers({limit: 1000});
      */
    },
    setRouteQuery() {
      let query = {
        ...this.query,
        page: `${this.page}`,
        from_date: this.fromDateFormat,
        to_date: this.toDateFormat,
        limit: this.limit,
      };
      if (!isEqual(query, this.$route.query)) {
        try {
          this.$router.push({ query: query });
        } catch (error) {}
      }
    },
    getItems(search) {
      if (!this.userCan("trips.read")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }

      if (this.page > 1 && this.page > this.trips.pagination.pages) {
        this.page = this.trips.pagination.pages;
      }
      if (this.page < 1) {
        this.page = 1;
      }

      let payload = {
        ...this.query,
        limit: this.limit,
        page: this.page,
        from_date: this.fromDateFormat,
        to_date: this.toDateFormat,
      };

      if (search) {
        payload.search = search;
      }
      if (this.partner_namespace) {
        payload.partner_id = this.partner_namespace;
      }
      this.setRouteQuery();
      this.$vs.loading({ type: "point" });
      this.fetchTrips(payload)
        .then((data) => {
          setTimeout(() => {
            this.activeLoading = false;
            this.$vs.loading.close();
          }, 500);
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    handleSearch(searching) {
      this.page = 1;
      this.search = searching === "" ? null : searching;
      this.doSearch(searching);
    },
    edit(row) {
      if (this.partner_namespace) {
        return { name: "partner.trips.details", params: { trip_id: row } };
      } else {
        return { name: "trips details", params: { trip_id: row } };
      }
    },
    Masssave() {
      console.log("+++SAVE TRIPS++");
      if (this.partner_id) {
        console.log("+++this.zone_id++", this.partner_id);
        this.handleFilesUpload();
      } else {
        alert("Select a Partner.");
      }
    },
    handleFilesUpload() {
      this.submitFile(this.$refs.file.files[0]);
    },
    checkprogress(data_id) {
      let payload = { task_id: data_id };
      this.CheckRoutesProgress(payload)
        .then((data) => {
          /* for (var i=0; i < this.partners.partners.length; i++) {
              if (this.partners.partners[i].id === this.partner_id) {
                  this.partnernamespace= this.partners.partners[i].name;
              }
          }*/
          this.progress = 0;
          console.log("CheckRoutesProgress data", data);
          this.showProgress = true;
          if (data.status === "FAILURE") {
            this.errors_array = null;
            this.errors_array = data.errors;
            this.showError = true;
            this.showProgress = false;
            this.$vs.loading.close();

            setTimeout(() => {}, 500);
            return false;
          }
          if (data.progress != 100) {
            // this.progress = data.progress;
            setTimeout(() => {
              this.checkprogress(data_id);
            }, 1000);
          } else {
            this.progress = 100;
            this.displayForm = false;
          }
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.log("CheckRoutesProgress error:", error);
          alert("Error on Import.");
          // this.progress = 0;
          this.showProgress = false;
          this.$vs.loading.close();
        });
    },
    submitFile(file) {
      this.$vs.loading({ type: "point" });
      let formData = new FormData();
      formData.append("file", file);
      formData.append("partner_id", this.partner_id);
      this.MassLoadTrips(formData)
        .then((data) => {
          if (data.id) {
            this.checkprogress(data.id);
            this.$vs.loading.close();
          }
        })
        .catch((error) => {
          console.log("error:", error);
          if (error.status === 400) {
            this.errors_array = null;
            this.errors_array = error.data.errors;
            this.errors_detail = error.data.detail;
            this.showError = true;
          }
          this.$vs.loading.close();
        });
    },

    uploadFile() {
      console.log("uploadFile");
      this.showError = false;
    },
    cancel() {
      this.displayForm = false;
    },
    Exportxls() {
      console.log("export xls");

      var targetexport = {
        ...this.filters,
        export: true,
        from_date: moment(this.fromDate).format("YYYY-MM-DD"),
        to_date: moment(this.toDate).format("YYYY-MM-DD"),
        format: "csv",
      };
      if (targetexport.partner_id) {
        targetexport.partner_id = targetexport.partner_id.value;
      }
      if (targetexport.route_id) {
        targetexport.route_id = targetexport.route_id.value;
      }
      if (targetexport.zone_id) {
        targetexport.zone_id = targetexport.zone_id.value;
      }
      if (targetexport.driver_id) {
        targetexport.driver_id = targetexport.driver_id.value;
      }
      if (targetexport.vehicle_id) {
        targetexport.vehicle_id = targetexport.vehicle_id.value;
      }
      if (targetexport.status) {
        targetexport.status = targetexport.status.value;
      }

      if (this.partner_namespace != null) {
        if (!targetexport.partner_id) {
          targetexport.partner_id = this.partner_namespace;
        }
      }
      targetexport.page = 1;
      this.$vs.loading({ type: "point" });
      this.fetchTripsReport(targetexport)
        .then((data) => {
          FileDownload(
            data,
            `trips-${moment(this.fromDate).format("YYYY-MM-DD")}-${moment(
              this.toDate
            ).format("YYYY-MM-DD")}.csv`
          );
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    showTrip(row) {
      return {
        name: this.partner_namespace
          ? "partner.trips.details"
          : "trips details",
        params: { trip_id: row },
      };
    },
    copy(id) {
      if (this.partner_namespace) {
        return { name: "partner.trips.add", query: { trip_id: id } };
      } else {
        return { name: "trips.add", query: { trip_id: id } };
      }
    },
    MassLoad() {
      console.log("mass load");
      this.formTitle = "Mass Charge";
      this.displayForm = true;
    },
    updateDate() {
      this.activeLoading = true;
      this.$vs.loading({
        type: "point",
      });
      this.getItems();
    },
    openConfirm(id) {
      if (!this.userCan("trips.delete")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure yo want to delete this record?\n This cannot be undone!",
        accept: () => {
          this.deleteTrip({ id })
            .then((data) => {
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: "Deleted successfully",
              });
              this.getItems();
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: "Something went wrong",
              });
            });
        },
      });
    },
    toggleSidebar(val = false) {
      this.showSidebar = val;
    },
    applyFilters(filters) {
      this.page = 1;
      console.log("applyFilters");
    },
    removeFilter(key) {
      let filters = _.cloneDeep(this.formattedFilters);
      delete filters[key];
      this.SET_FILTERS(filters);
    },
    getChipColor(status) {
      if (status === "pending") {
        return "warning";
      } else if (status === "processing") {
        return "danger";
      } else if (status === "completed") {
        return "success";
      } else {
        return "success";
      }
    },
    timeFormat(time) {
      return moment(time, "HH:mm:ss").format("HH:mm");
    },
    getChipStationColor(tripStatus, stationStatus) {
      if (tripStatus === "pending" || tripStatus === "cancelled") {
        return "dark";
      }
      if (stationStatus === "pending") {
        return "warning";
      }
      if (stationStatus === "completed") {
        return "success";
      }
      return "primary";
    },
    cloneDialog(type) {
      let form = {
        source: {
          type: type,
          ids: [],
        },
        schedule: {
          start_date: null,
          end_date: null,
          exclude: [],
        },
      };
      if (type === "TRIP") {
        form.source.ids = this.selected;
      }
      this.cloneForm = _.cloneDeep(form);

      this.showCloneForm = true;
    },
    cancelCloneDialog() {
      this.showCloneForm = false;
      let form = {
        source: {
          type: null,
          ids: [],
        },
        schedule: {
          start_date: null,
          end_date: null,
          exclude: [],
        },
      };
      this.cloneForm = _.cloneDeep(form);
      this.selected = [];
      this.submitClone = false;
      this.getItems();
    },
    selectDates() {
      let form = _.cloneDeep(this.cloneForm);
      form.source.ids = this.selected;
      this.cloneForm = _.cloneDeep(form);
    },
    async cloneTrips() {
      if (!(await this.$validator.validateAll())) {
        return;
      }
      if (this.submitClone) {
        return;
      }
      this.submitClone = true;
      let form = _.cloneDeep(this.cloneForm);

      this.$vs.loading({ type: "point" });

      this.storeBulkTrips(form)
        .then((data) => {
          this.$vs.loading.close();

          this.$vs.notify({
            color: "success",
            title: `Success`,
            text: "Cloning is complete",
          });

          this.cancelCloneDialog();
        })
        .catch((error) => {
          this.submitClone = false;
          this.$vs.loading.close();
        });
    },
    getRowState(trip) {
      if (this.selected.indexOf(trip.id) > -1) {
        return "primary";
      }
      if (trip.status === "processing") {
        return "danger";
      }
      if (trip.status === "completed") {
        return "success";
      }
      return "";
    },
    bulkDelete() {
      console.log("delete");
      if (!this.userCan("trips.delete")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure yo want to delete this records?\n This cannot be undone!",
        accept: () => {
          this.$vs.loading({ type: "point" });
          this.bulkDeleteTrips(this.selected)
            .then(() => {
              this.$vs.loading.close();
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: "Something went wrong",
              });
              this.$vs.loading.close();
            });
        },
      });
    },
  },
};
</script>
